import { connect } from 'react-redux'

import { getCurrentUserEmail } from '../../store/AppState/selector'
import { signOut } from '../../store/AppState/actions'
import { selectVenue, fetchVenues } from '../../store/Venues/actions'

import { getVenues, getCurrentVenue } from '../../store/Venues/selector'

import { ORG_NAME } from '../../utils/env'
import Sidebar from '../../components/Layout/Sidebar'

const mapStateToProps = state => ({
  userEmail: getCurrentUserEmail(state),
  orgName: ORG_NAME,
  venues: getVenues(state),
  currentVenue: getCurrentVenue(state),
})

const mapDispatchToProps = dispatch => ({
  signOut: () => dispatch(signOut()),
  selectVenue: (value) => dispatch(selectVenue(value)),
  fetchVenues: () => dispatch(fetchVenues()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)
